// src\themes\tolica\elements\Header\HeaderNavToggle.tsx
"use client";

import { useDrawerStoreTolica } from "@/stores/drawerStore";


export default function HeaderNavToggle() {
  const { setOpen } = useDrawerStoreTolica();


  return (
    <button
      onClick={() => setOpen(true)}
      className="lg:hidden"
    >
      <svg className="w-6" viewBox="0 0 24 24" stroke="#fff" fill="#fff" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" d="M3 6H21M3 12H11M3 18H16"></path>
      </svg>
    </button>
  );
}
